/* ═══════════════════════════════════════════════════════════════
   Cart quantity stepper.

   The cart form already works on its own: type a number, press Update.
   All this does is make the − and + buttons submit for you, and hide
   the Update button once it has proved it can.

   That order matters. The button is hidden by a data attribute this
   script sets, not by a noscript rule — so a script that fails to load,
   or is blocked after the page renders, leaves a visitor with a working
   button rather than a stepper that does nothing.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function step(form) {
    form.querySelectorAll('[data-gmd-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var row = button.closest('.qty');
        var input = row && row.querySelector('[data-gmd-qty-input]');
        if (!input) return;

        var by = parseInt(button.getAttribute('data-gmd-qty'), 10) || 0;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + by);
        if (next === (parseInt(input.value, 10) || 0)) return;

        input.value = String(next);
        submit(form);
      });
    });

    // Typing a quantity and tabbing away should behave like pressing Update.
    form.querySelectorAll('[data-gmd-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        submit(form);
      });
    });
  }

  function submit(form) {
    var update = form.querySelector('[data-gmd-update]');
    // requestSubmit carries the button's name=update with it, which is what
    // tells Shopify to apply updates[] rather than fall through to checkout.
    if (update && form.requestSubmit) {
      form.requestSubmit(update);
    } else if (update) {
      update.click();
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gmd-cart]').forEach(function (form) {
      if (form.dataset.gmdEnhanced) return;
      step(form);
      form.dataset.gmdEnhanced = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
